<template>
<div class="container">
    <div class="content">
        <div class="chart">
            <img id="img1" class="img" v-if="pic.length > 0" :src="`${pic1Url}`" alt />
        </div>
        <div class="info">
            <div>
                <span class="h3 value">{{ info.total_watt }}</span>
                <span class="unit">KW</span>
            </div>
            <div class="h2">{{ info.location + info.name }}</div>
            <div class="h5">
                <span class="label">掛錶日：</span>
                <span class="value">{{ info.date }}</span>
            </div>
            <div class="h5">
                <span class="label">單價：</span>
                <span class="value">{{ info.price }}</span>
                <span class="unit">(元/度)</span>
            </div>
        </div>
        <div class="message">
            <div class="data">
                <div class="data-item">
                    <span class="label">即時發電量：</span>
                    <span class="value">{{ watt | formatNumber }}</span>
                    <span class="unit">kw</span>
                </div>
                <div class="data-item">
                    <span class="label">累積減碳量：</span>
                    <span class="value">{{ co2 | formatNumber }}</span>
                    <span class="unit">kg</span>
                </div>
            </div>
            <div class="data">
                <div class="data-item">
                    <span class="label">今日度數：</span>
                    <span class="value">{{ kwh }}</span>
                    <span class="unit">度</span>
                </div>
                <div class="data-item">
                    <span class="label">今日收入：</span>
                    <span class="value">{{ money | formatMoney }}</span>
                    <span class="unit">元</span>
                </div>
            </div>
            <div class="data">
                <div class="data-item">
                    <span class="label">累積度數：</span>
                    <span class="value">{{ totalKwh }}</span>
                    <span class="unit">度</span>
                </div>
                <div class="data-item">
                    <span class="label">累積收入：</span>
                    <span class="value">{{ totalMoney | formatMoney }}</span>
                    <span class="unit">元</span>
                </div>
            </div>
        </div>
    </div>

    <div class="footer">
        <div></div>
        <div class="footer-title"> ® XINYU 信宇開發
            <a href="http://www.xinyu2008.com.tw" target="_blank">監控系統</a></div>
        <div id="status">{{ status }}</div>
    </div>
</div>
</template>

<script>
export default {
    name: "MainIE",
    data() {
        return {
            id: "",
            info: "",
            now: "",
            increase: "",
            status: "",
            pic: "",
            pic1Url: "",
        };
    },
    created() {
        this.id = this.$route.params.id;

        this.$http
            .get(process.env.VUE_APP_SOALR_URL + `/api/solar/records/${this.id}`)
            .then((res) => {
                const data = res.data.data;

                var status = res.data.status;
                var message = status["message"];

                if (message === "closed" || message === "expire") {
                    this.status = "您的監控方案已到期，請盡速和您系統商連絡~! 謝謝~";
                    this.now = "";
                    this.increase = "";
                } else {
                    if (message === "remind") {
                        this.status =
                            "您的監控方案將於" +
                            Math.abs(status["days"]) +
                            "天後到期，請盡速和您系統商連絡~! 謝謝~";
                    }

                    this.now = data.now;
                    this.increase = data.increase;
                }
            });

        this.$http
            .get(process.env.VUE_APP_SOALR_URL + `/api/solar/infos/${this.id}`)
            .then((res) => {
                const data = res.data;
                this.info = data.info;
                this.pic = data.pic;
                this.pic1Url = this.pic[0].url;
            });
    },
    mounted() {
        this.getData();
    },
    methods: {
        getData: function () {
            let my = this;
            setInterval(function () {
                const id = my.$route.params.id;

                my.$http
                    .get(process.env.VUE_APP_SOALR_URL + `/api/solar/records/${id}`)
                    .then((res) => {
                        const data = res.data.data;

                        var status = res.data.status;
                        var message = status["message"];

                        if (message === "closed" || message === "expire") {
                            my.status = "您的監控方案已到期，請盡速和您系統商連絡~! 謝謝~";
                            my.now = "";
                            my.curve = "";
                            my.increase = "";
                        } else {
                            if (message === "remind") {
                                my.status =
                                    "您的監控方案將於" +
                                    Math.abs(status["days"]) +
                                    "天後到期，請盡速和您系統商連絡~! 謝謝~";
                            }
                            my.now = data.now;
                            my.increase = data.increase;
                        }
                    });

                my.$http
                    .get(process.env.VUE_APP_SOALR_URL + `/api/solar/infos/${id}`)
                    .then((res) => {
                        const data = res.data;
                        my.info = data.info;
                        my.pic = data.pic;
                        this.pic1Url = this.pic[0].url;
                    });
            }, 30000);
        },
    },
    computed: {
        co2: function () {
            return !this.now || !this.increase ?
                0 :
                (parseInt(this.now.kwh_total) +
                    parseInt(this.increase.original) -
                    parseInt(this.increase.new)) *
                0.636;
        },
        kwh: function () {
            return !this.now ? 0 : this.now.kwh_today / 1000;
        },
        watt: function () {
            return !this.now ? 0 : this.now.watt_dc / 1000;
        },
        money: function () {
            return this.kwh * this.info.price;
        },
        totalKwh: function () {
            return !this.now || !this.increase ?
                0 :
                parseInt(this.now.kwh_total) +
                parseInt(this.increase.original) -
                parseInt(this.increase.new);
        },
        totalMoney: function () {
            return this.totalKwh * this.info.price;
        },
        historyKwh: function () {
            return this.history.kwh / 1000;
        },
    },
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/main_ie.scss";
</style>
